import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { v4 as uuid } from "uuid";

import type { ChatSession, SalesforceChatConfig } from "../types/chat";
import { agentsService } from "services/agents";

interface SendMessageParams {
  chatId?: string;
  prompt: string;
  accessToken: string;
}

interface SendMessageInput {
  text: string;
  session: ChatSession;
}

export function useSendMessage() {
  return useMutation({
    mutationFn: ({ accessToken, chatId, prompt }: SendMessageParams) =>
      agentsService.sendMessage(accessToken, { prompt, chatId }),
    retry: 0,
  });
}

export function useEnhancedChatSendMessage(config: SalesforceChatConfig) {
  return useMutation<void, Error, SendMessageInput>({
    mutationFn: async ({ session, text }) => {
      const url = `${config.scrtUrl}/iamessage/api/v2/conversation/${session.conversationId}/message`;

      const body = {
        message: {
          id: uuid(),
          messageType: "StaticContentMessage",
          staticContent: {
            formatType: "Text",
            text,
          },
        },
        esDeveloperName: config.esDeveloperName,
        isNewMessagingSession: false,
        routingAttributes: {},
        language: "pt-BR",
      };

      await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${session.accessToken}`,
          "Content-Type": "application/json",
        },
      });
    },
  });
}
